import { transactionTypes } from '../../../../../assets/helpers/options';

export const parseTitle = (paymentType, membershipId) => {
  let message = '';

  switch (paymentType) {
    case transactionTypes.UPGRADE:
      message = `Upgrade Orden Nro. ${membershipId}`;
      break;
    case transactionTypes.RCV:
      message = `Solicitud de RCV para: ${membershipId}`;
      break;
    case transactionTypes.RENEWAL:
      message = `Orden por renovacion: ${membershipId}`;
      break;
    case transactionTypes.DUE_PAYMENT:
      message = `Pago pendiente Orden: ${membershipId}`;
      break;
    case transactionTypes.MEDICAL_CERT:
      message = `Solicitud de Certificado Médico para: ${membershipId}`;
      break;
    case transactionTypes.RCV_CARD:
      message = `Solicitud de Tarjeta RCV para: ${membershipId}`;
      break;
    default:
      message = `Orden Nro. ${membershipId}`;
      break;
  }

  return message;
};
